<div *ngIf="(pageVm$ | async) as vm">

    <!-- loader -->
    <app-page-loader [pageLoaderVm]="vm"></app-page-loader>

    <!-- not logged in view -->
    <div *ngIf="!vm.isLoggedIn && !vm.workingText">
        <div class="row">
            <div class="col-lg-6">
                <div class="jumbotron">
                    <h1 class="display-4">Welcome to the Wealth Calculator!</h1>
                    <p class="lead">
                        This tool will allow you to simulate and forecast the cashflow, appreciation, and ROI of owning multiple properties over a period of time.
                    </p>
                </div>                   
            </div>
            <div class="col-lg-6">
                <app-auth></app-auth>
            </div>
        </div>
        
    </div>

    <!-- logged in view -->
    <div *ngIf="vm.isLoggedIn">

        <!-- welcome -->
        <div *ngIf="vm.showWelcome">
            <div class="jumbotron">
                <h1 class="display-4">Welcome to the Wealth Calculator!</h1>
                <p class="lead">
                    This tool will allow you to simulate and forecast the cashflow, appreciation, and ROI of owning multiple properties over a period of time.
                </p>
                <hr class="my-4">
                <div class="row">
                    <div class="col-md-6">
                        <img style="display: block; margin-left: auto; margin-right: auto; width: 75%" src="../../../assets/tool-screenshot.jpg"/>
                    </div>
                    <div class="col-md-6 text-center">
                        <p>To get started please click one of the links below</p>
                        <app-form-button color="primary" size="lg" [rounded]="true" title="Load Samples" (click)="propertyListActionStart(vm, 'load-samples')"></app-form-button>
                        <app-form-button color="primary" size="lg" [rounded]="true" title="Add a Property" (click)="propertyListActionStart(vm, 'property-add')"></app-form-button>        
                    </div>
                </div>

            </div>            
        </div>

        <!-- dashboard -->
        <div *ngIf="vm.dashboardVm as dvm">

            <!-- slider -->
            <div *ngIf="dvm.sliderVm as svm" class="pb-3">
                <div class="d-flex justify-content-center align-items-center">
                    <span class="font-weight-bold rtr-text-green-dark mr-2">{{svm.min}} year(s)</span>
                    <form class="my-3 w-50">
                        <mdb-range-input id="range" [min]="svm.min" [value]="svm.current" [max]="svm.max"
                            (rangeValueChange)="sliderChanged(vm, $event)"
                            mdbTooltip="Adjust # of years of anticipated hold time" placement="bottom">
                        </mdb-range-input>
                    </form>
                    <span class="font-weight-bold rtr-text-green-dark ml-2">{{svm.max}} year(s)</span>
                    <app-form-help [html]="'Move slider to adjust # of years of anticipated hold time'"></app-form-help>
                </div>
            </div>

            <!-- cards -->
            <div class="d-flex justify-content-around flex-wrap">
                <div class="pb-3" style="min-width: 180px;" *ngFor="let c of dvm.cards">
                    <mdb-card bgColor="rtr-background-green-bold" class="classic-admin-card">
                        <mdb-card-body class="py-1">
                            <div class="text-center">
                                <span class="white-text">{{c.title}}</span>
                                <app-form-help [html]="c.helpText"></app-form-help>
                            </div>
                            <h4 class="text-center">
                                <strong>{{c.value}}</strong>
                            </h4>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>

            <!-- content -->
            <div class="row">

                <div class="col-md-12">

                    <!-- charts -->
                    <div class="row">

                        <div class="pb-3 col-md-6" *ngFor="let cvm of dvm.charts">

                            <mdb-card narrower="true" cascade="true">
                                <div class="row">
                                    <div class="col-md-8 pr-0">
                                        <app-card-header [headingSize]="5" [title]="cvm.title" [helpHtml]="cvm.helpHtml">
                                        </app-card-header>
                                    </div>
                                </div>

                                <mdb-card-body cascade="true">
                                    <p class="text-center">{{cvm.bodyText}}</p>
                                    <div style="display: block;">
                                        <canvas mdbChart [chartType]="cvm.chartType" [datasets]="cvm.chartDatasets"
                                            style="max-height: 180px;" [labels]="cvm.chartLabels"
                                            [colors]="cvm.chartColors" [options]="cvm.chartOptions" [legend]="false"
                                            (chartHover)="chartVm_clicked(vm, cvm, $event)"
                                            (chartClick)="chartVm_hovered(vm, cvm, $event)">
                                        </canvas>
                                    </div>
                                </mdb-card-body>
                            </mdb-card>
                        </div>

                    </div>

                    <!-- properties -->
                    <div class="row" *ngIf="dvm.propertyListVm as plvm">
                        <div class="col-md-12 pb-3">

                            <!-- heading -->
                            <div class="d-flex justify-content-start align-items-center flex-wrap">

                                <app-card-header [isStandalone]="true" [headingSize]="5" [title]="plvm.title"
                                    helpHtml=""></app-card-header>

                                <div *ngIf="plvm.actions" class="pl-3">
                                    <a class="action-link" *ngFor="let a of plvm.actions" (click)="propertyListActionStart(vm, a.code)">
                                        {{a.name}}
                                    </a>
                                </div>

                            </div>

                            <!-- property display -->
                            <div class="d-flex justify-content-around flex-wrap">

                                <div class="pb-3" style="width: 360px;" *ngFor="let pvm of plvm.propertyVms; let ndxPvm = index">

                                    <!-- property card -->
                                    <mdb-card cascade="true" narrower="true" *ngIf="pvm.displayVm as pdvm">
                                        <div class="view overlay zoom waves-light" style="height: 180px; "
                                            mdbWavesEffect>
                                            <app-form-file-image [imageData]="pdvm.pictureUrl"></app-form-file-image>
                                            <!-- <img [src]="pdvm.pictureUrl" class="img-fluid"> -->
                                            <a [routerLink]="['properties', pdvm.code]">
                                                <div class="mask flex-center rgba-green-light">
                                                    <p class="white-text">View Property</p>
                                                </div>
                                            </a>
                                        </div>
                                        <mdb-card-body cascade="true" class="text-center">
                                            <h4 class="card-title mb-2 font-bold">
                                                <strong>{{pdvm.name}}</strong>
                                            </h4>
                                            <div style="height: 2em;">
                                                <small>{{pdvm.address}}</small>
                                            </div>

                                            <hr />

                                            <div class="row" *ngFor="let d of pdvm.details">
                                                <div class="col-6 text-right pr-1"><small>{{d.title}}:</small></div>
                                                <div class="col-6 text-left pl-1">
                                                    <strong>{{d.value}}</strong>
                                                </div>
                                            </div>

                                        </mdb-card-body>
                                        <mdb-card-footer>
                                            <div class="d-flex justify-content-center" *ngIf="!pdvm.workingText">
                                                <a class="action-link waves-light pr-3" [routerLink]="['properties', pdvm.code]"
                                                    [mdbTooltip]="'Show the property details'" mdbWavesEffect>View</a>
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" class="custom-control-input" [id]="'customSwitch_' + ndxPvm"                                                          
                                                        [ngModel]="pdvm.include" (ngModelChange)="includeChanged(vm, pvm, $event)">
                                                    <label class="custom-control-label" [for]="'customSwitch_' + ndxPvm">Include</label>
                                                </div>
                                            </div>
                                            <div class="text-center" *ngIf="pdvm.workingText">
                                                <span>{{pdvm.workingText}}</span>                                                
                                            </div>
                                            <div class="text-center danger-text" *ngIf="pdvm.errorText">
                                                <span>{{pdvm.errorText}}</span>                                                
                                            </div>
                                        </mdb-card-footer>

                                    </mdb-card>

                                    <div class="text-danger">
                                       <span>{{pvm.errorText}}</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>